import { Card, Heading, LoadingSkeleton } from '@boltenergy-be/design-system'
import classNames from 'classnames'
import { DashboardCardProps } from './types.ts'
import styles from './DashboardCard.module.scss'
import ExportButton from './ExportButton.tsx'
import { useStoreSelector } from 'hooks/store.ts'
import { ROLES } from '@boltenergy-be/shared'

const DashboardCard = ({
  title,
  description,
  handleExport,
  variant,
  children,
  className,
  canExport = true,
  disableExport,
  loading
}: DashboardCardProps) => {
  // Redux
  const { role } = useStoreSelector((store) => store.sales)

  // Constants
  const exportButton = canExport && role === ROLES.salesManager && !loading ? <ExportButton {...{ handleExport, disableExport }} /> : null

  return (
    <Card data-variant={variant} className={classNames(styles.card, className)}>
      <header className={styles.header}>
        <Heading as="h3" variant="h6" weight="semi-bold" className={styles.title}>
          {title}
        </Heading>
        {!!description && <small className={styles.description}>{description}</small>}

        {variant === 'large' && exportButton}
      </header>

      {loading ? (
        <LoadingSkeleton>
          <LoadingSkeleton.Rectangle width="100%" aspectRatio="3 / 1" />
        </LoadingSkeleton>
      ) : (
        children
      )}

      {variant === 'small' && !!exportButton && <footer className={styles.footer}>{exportButton}</footer>}
    </Card>
  )
}

export default DashboardCard
